import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import { useSubscription } from "utils/useSubscription";

import PlansPrice from "../SharedComponents/Price";
import { PlanAction, getCurrentPlanButton } from "../helpers";

const MobilePlanCardPro = () => {
  const { onPlanButtonClick } = useSubscription();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { plans, subscription } = useContext(SubscriptionContext);
  const totalEmails = plans?.[Plans.PRO]?.monthly_limit || 0;
  const action = getCurrentPlanButton(
    Plans.PRO,
    subscription?.subscription?.planName || Plans.FREE,
    subscription,
  );

  return (
    <Box sx={{ backgroundColor: "white", borderRadius: 3, mt: 1 }}>
      <Grid container justifyContent={"flex-end"} sx={{ pr: 1.5, pt: 1.5 }}>
        <Box
          sx={{
            backgroundColor: "yellow.main",
            borderRadius: 6,
            px: 2,
            py: 0.5,
            fontSize: 11,
            mb: 2,
            fontWeight: 600,
          }}
        >
          11x more likely to land a deal
        </Box>
      </Grid>

      <Box sx={{ px: 2, pb: 3 }}>
        <Grid container justifyContent="space-between" alignItems="flex-end">
          <Typography variant="h4" sx={{ fontSize: 26 }}>
            Pro Plan
          </Typography>
          <PlansPrice plan={Plans.PRO} />
        </Grid>

        <Divider sx={{ my: 1, backgroundColor: "black" }} />

        <Typography sx={{ fontSize: 14, lineHeight: 2 }}>
          🚀 Send {totalEmails} Emails per month
          <br />
          🧠 Advanced brand filters <br />
          📈 Reply likelihood for each contact <br />
          🔑 Get access to 600k contacts <br />
          💰 Monthly reminders to close deal
        </Typography>

        {!currentOrg?.overridePlanName && (
          <Button
            disableElevation
            fullWidth
            variant={action === PlanAction.upgrade ? "contained" : "text"}
            sx={{
              fontSize: 16,
              mt: 2,
              py: 1,
              borderRadius: 2,
              backgroundColor:
                action === PlanAction.upgrade ? "primary.main" : "#f4f8f6",
            }}
            onClick={() => onPlanButtonClick(Plans.PRO, action)}
          >
            Upgrade to Pro
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default MobilePlanCardPro;
